import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiYrVipPackage extends apiCommonCategory{
  static module = 'yr_vip_package'


}
